import { calculateCanvasHeight } from '../calculateCanvasHeight/index.js';
import '../../configs/index.js';

var hasHorizontalScroll = function hasHorizontalScroll(scale) {
  return scale >= 1;
};
var hasVerticalScroll = function hasVerticalScroll(heightParams) {
  return calculateCanvasHeight(heightParams) > heightParams.cssHeight;
};

export { hasHorizontalScroll, hasVerticalScroll };
